import { required } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { DateInput } from "@/components/admin/date-input";
import { TextInput } from "@/components/admin/text-input";

export const ProgramInputs = () => (
  <div className="flex flex-col gap-4 p-1 max-w-xl">
    <TextInput source="name" validate={required()} helperText={false} />
    <TextInput source="season" helperText={false} />
    <TextInput source="description" multiline rows={3} helperText={false} />
    <div className="flex gap-4">
      <DateInput source="starts_on" className="flex-1" helperText={false} />
      <DateInput source="ends_on" className="flex-1" helperText={false} />
    </div>
    <BooleanInput source="active" />
  </div>
);
